export default "__VITE_ASSET__Bx5nhE4R__"